<template>
  <CContainer>
    <CDataTable
      hover
      responsive
      pagination
      :itemsPerPage="5"
      :items="records"
      :fields="gridFields">
      <template #producto="{item}">
        <td>
          <div>
            <span>{{ item.descripcion }}</span>
          </div>
          <div v-if="editingRowId !== item.id_MovimientoDocumentoDIAN"
            class="d-flex align-items-start">
            <h5>{{ item.codigo }}</h5>
            <a href="#" @click="startEditing($event, item)">
              <i class="bi bi-pencil text-warning ml-2"></i>
            </a>
          </div>
          <CInput v-else 
            size="sm"
            v-model="editingRowNewData"
            ref="editInput" 
            @blur="saveEditing(item)"
            @keyup.enter="saveEditing(item)"
            @keyup.esc="cancelEditing" />
          <div>
            <i class="bi bi-coin mr-1" v-c-tooltip="'Valor mercancia'"></i>
            <span>${{ formatter.format(item.valor_Producto, 2) }}</span>
          </div>
          <div>
            <i class="bi bi-box-seam mr-1"></i>
            <span class="font-weight-bold">{{ formatter.format(item.cantidad, 2) }}</span>
          </div>
        </td>
      </template>
      <template #valores="{item}">
        <td>
          <div class="text-right">
            <span>${{ formatter.format(item.valor_Subtotal, 2) }}</span>
            <i class="bi bi-cash-coin ml-1" v-c-tooltip="'Valor subtotal'"></i>
          </div>
          <div class="text-right">
            <span>${{ formatter.format(item.valor_Impuestos, 2) }}</span>
            <i class="bi bi-percent ml-1" v-c-tooltip="'Valor impuestos'"></i>
          </div>
          <!-- <div class="text-right">
            <span class="font-weight-bold">{{ formatter.format(item.cantidad, 2) }}</span>
            <i class="bi bi-box-seam ml-1"></i>
          </div> -->
        </td>
      </template>
      <template #impuestos="{item}">
        <td>
          <div class="text-right">
            <span class="text-success" v-c-tooltip="'Valor IVA'">${{ formatter.format(item.valor_IVA, 2) }}</span>
          </div>
          <div class="text-right">
            <span class="text-danger" v-c-tooltip="'Valor INC'">${{ formatter.format(item.valor_INC, 2) }}</span>
          </div>
          <div class="text-right">
            <span class="text-warning" v-c-tooltip="'Valor ICUI'">${{ formatter.format(item.valor_ICUI, 2) }}</span>
          </div>
          <div class="text-right">
            <span class="text-warning" v-c-tooltip="'Valor IBUA'">${{ formatter.format(item.valor_IBUA, 2) }}</span>
          </div>
        </td>
      </template>
    </CDataTable>
    <CPagination 
      size="sm" 
      class="d-flex justify-content-center" 
      :activePage.sync="page" 
      :pages="pageCount"
      @update:activePage="(value, a) => getData(value, searchWord)">
    </CPagination>

    <LoadingCover v-show="loading"/>
  </CContainer>
</template>

<script>
  import moment from "moment";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { formatter } from "@/general";
  import { 
    crudMovimientosDocumentoDian,
    dataGridMovimientosDocumentoElectronico
  } from "@/apis/electronic-documents";

  const gridFields = [
    {
      key: "producto",
      label: "Producto",
      _style: "text-align:center"
    },
    {
      key: "valores",
      label: "Valores",
      _style: "text-align:center"
    },
    {
      key: "impuestos",
      label: "Impuestos",
      _style: "text-align:center"
    }
  ]

  export default {
    name: "ElectronicDocumentMovements",
    data () {
      return {
        formatter,
        loading: false,
        gridFields,
        records: [],
        numberRecords: 0,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        editingRowId: null,
        editingRowNewData: "",
        editingRowOriginalData: ""
      }
    },
    components: {
      LoadingCover
    },
    props: {
      electronicDocumentId: String
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.page = page;
        this.searchWord = search;

        if (this.electronicDocumentId) {
          try {
            const { count, results } = await dataGridMovimientosDocumentoElectronico(this, page, search, this.electronicDocumentId);
  
            console.log("Registros ", count);
            console.log("Datos ", results);
            
            
  
            this.pageCount = parseInt(count / this.itemsPerPage);
            if (this.pageCount < (count / this.itemsPerPage)) {
              this.pageCount++;
            }
            this.records = results;
          } catch(error) {
            console.log(error);
            
            this.$store.commit("setAlert", {
              color: "danger",
              message: "NO se pudo cargar los datos!",
              show: 5
            });
          } finally {
            this.loading = false;
          }
        }
      },
      startEditing(e, item) {
        e.preventDefault();
        e.stopPropagation();

        if (this.editingRowId !== null && this.editingRowId !== item.id_MovimientoDocumentoDIAN) {
          this.cancelEditing();
        }

        this.editingRowId = item.id_MovimientoDocumentoDIAN;
        this.editingRowNewData = item.codigo;
        this.editingRowOriginalData = item.codigo;

        this.$nextTick(() => {
          if (this.$refs.editInput) {
            const inputElement = this.$refs.editInput.$el.querySelector("input");
            if (inputElement) {
              inputElement.focus();
            }          
          }
        });
      },
      async saveEditing(item) {
        if (this.editingRowId === item.id_MovimientoDocumentoDIAN) {
          try {
            const datos = {
              "codigo": this.editingRowNewData
            };
            const data = await crudMovimientosDocumentoDian(this, "patch", item.id_MovimientoDocumentoDIAN, datos);

            if (data) {
              item.codigo = this.editingRowNewData;
              this.$store.commit("setAlert", {
                color: "success",
                message: "¡Código actualizado exitosamente!",
                show: 5
              });
            } else {
              this.$store.commit("setAlert", {
                color: "danger",
                message: "¡Error al actualizar el código!",
                show: 5
              });
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.cancelEditing();
          }
        }
      },
      cancelEditing() {
        this.editingRowId = null;
        this.editingRowNewData = "";
        this.editingRowOriginalData = "";
      }
    },
    mounted() {
      console.log(this.electronicDocumentId);
      
      this.getData();
    }
  }
</script>
